/**
 * Convert a Monaco editor inlay hint kind to an LSP inlay hint kind.
 *
 * @param inlayHintKind
 *   The Monaco inlay hint kind to convert.
 * @returns
 *   The inlay hint kind as an LSP inlay hint kind.
 */
export function fromInlayHintKind(inlayHintKind) {
    return inlayHintKind;
}
/**
 * Convert an LSP inlay hint kind to a Monaco editor inlay hint kind.
 *
 * @param inlayHintKind
 *   The LSP inlay hint kind to convert.
 * @returns
 *   The inlay hint kind as Monaco editor inlay hint kind.
 */
export function toInlayHintKind(inlayHintKind) {
    return inlayHintKind;
}
//# sourceMappingURL=inlayHintKind.js.map